import { render } from "./CreateTicketModal.vue?vue&type=template&id=67de6e12&scoped=true"
import script from "./CreateTicketModal.vue?vue&type=script&lang=js"
export * from "./CreateTicketModal.vue?vue&type=script&lang=js"

import "./CreateTicketModal.vue?vue&type=style&index=0&id=67de6e12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67de6e12"]])

export default __exports__